<template>
  <div>
    <multiselect placeholder="Bitte auswählen" v-model="chosenOptions" :options="options" :multiple="true" />
    <b-form-group class="col-md-6" v-for="choice in chosenOptions" :key="choice">
      <label> WE-Concentration: {{ choice }} {{ unit }} </label>
      <b-form-input type="text" v-model="entries[choice]" />
    </b-form-group>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'experiment-form',
  components: {
    Multiselect
  },
  props: {
    model: Object,
    options: Array,
    dbKey: String,
    unit: String
  },
  data () {
    return {
      chosenOptions: [],
      entries: {}
    }
  },
  methods: {
    resetForm () {
      this.chosenOptions = []
      this.entries = {}
    }
  },
  watch: {
    entries (e) {
      this.model[this.dbKey] = e
    },
    model (m) {
      if (m[this.dbKey]) {
        this.entries = m[this.dbKey]
      }
      if (this.entries) {
        this.chosenOptions = Object.keys(this.entries)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/plugins/ExperimentForm.vue